/* START_MODULE_CONTRACT
 * PURPOSE: Frontend API client для профиля и настроек текущего пользователя.
 * SCOPE: HTTP-вызовы /user/info и /user/settings.
 * DEPENDS: M-FE-API
 * LINKS: M-FE-API, V-M-FE-API, M-USER
 * END_MODULE_CONTRACT
 *
 * START_MODULE_MAP
 * getUserInfo - информация о пользователе.
 * getSettings - настройки пользователя.
 * updateSettings - обновить настройки.
 * END_MODULE_MAP
 *
 * START_CHANGE_SUMMARY
 * LAST_CHANGE: 2026-07-02 - GRACE coverage: function contracts и парные END_METHOD.
 * END_CHANGE_SUMMARY
 */

import apiClient from './apiClient';

/* START_METHOD_getUserInfo */
/* START_CONTRACT: getUserInfo
 * PURPOSE: Получить информацию о текущем пользователе.
 * INPUTS: { signal: AbortSignal }
 * OUTPUTS: { Promise<AxiosResponse> - GET /user/info }
 * SIDE_EFFECTS: HTTP-запрос к backend.
 * LINKS: M-USER
 * END_CONTRACT: getUserInfo
 */
export function getUserInfo(signal) {
  return apiClient.get('/user/info', { signal });
}
/* END_METHOD_getUserInfo */

/* START_METHOD_getSettings */
/* START_CONTRACT: getSettings
 * PURPOSE: Получить настройки текущего пользователя.
 * INPUTS: { signal: AbortSignal }
 * OUTPUTS: { Promise<AxiosResponse> - GET /user/settings }
 * SIDE_EFFECTS: HTTP-запрос к backend.
 * LINKS: M-USER
 * END_CONTRACT: getSettings
 */
export function getSettings(signal) {
  return apiClient.get('/user/settings', { signal });
}
/* END_METHOD_getSettings */

/* START_METHOD_updateSettings */
/* START_CONTRACT: updateSettings
 * PURPOSE: Обновить настройки текущего пользователя.
 * INPUTS: { settings: object }
 * OUTPUTS: { Promise<AxiosResponse> - PUT /user/settings }
 * SIDE_EFFECTS: HTTP-запрос к backend.
 * LINKS: M-USER
 * END_CONTRACT: updateSettings
 */
export function updateSettings(settings) {
  return apiClient.put('/user/settings', settings);
}
/* END_METHOD_updateSettings */
